import { resolveFieldData } from '../data-filter/resolve-field-data';
import { isNullOrUndefined } from '../utils/is-null-or-undefined';

/**
 * Gets the maximum number if the given set of data with the specified field
 * @param {any[]} items
 * @param {string} field
 * @returns {number}
 */
export function computeMaxNumber(items: any[], field: string): number {
  let highest = 0;

  // Guard
  if (isNullOrUndefined(items) || isNullOrUndefined(field)) {
    return highest;
  }

  for (const item of items) {
    const value = resolveFieldData(item, field);
    if (value === null) {
      continue;
    }

    if (value > highest) {
      highest = value;
    }
  }

  return highest;
}
